const TEMPLATE_PROVIDER_INVOICE = {
    'hoadon30s': {
        'format_code': {
            label: 'Mẫu hóa đơn',
            tooltip: 'Mẫu hóa đơn trên hệ thống hoadon30s',
            placeholder: 'Nhập mẫu hóa đơn',
            required: 'Vui lòng nhập mẫu hóa đơn',
        }
    },
    'me_invoice': {
        'format_code': {
            label: 'Mẫu hóa đơn',
            tooltip: 'Mẫu hóa đơn trên hệ thống MeInvoice',
            placeholder: 'Nhập mẫu hóa đơn',
            required: 'Vui lòng nhập mẫu hóa đơn',
        }
    }
}

const INVOICE_TYPE = [
    {
        value: 'GTGT',
        label: 'Hóa đơn thường'
    },
    {
        value: 'GTGT_MTT',
        label: 'Hóa đơn máy tính tiền'
    }
]

export { TEMPLATE_PROVIDER_INVOICE, INVOICE_TYPE };